import { Fragment } from 'react';

import { AccordionProps, Root, Separator } from './Accordion.ui';
import { Dropdown } from './components/Dropdown/Dropdown';

export const Accordion = ({ items, className, style }: AccordionProps) => (
  <Root className={className} style={style}>
    {items.map((item, index) => (
      <Fragment key={item.title}>
        <Dropdown title={item.title} desc={item.desc} />
        {index < items.length - 1 && <Separator />}
      </Fragment>
    ))}
  </Root>
);
